<template>
  <div @click="link(cardData)" class="card" :style="{backgroundImage: cardData.backgroundImage ? `url(${cardData.backgroundImage})` : '#f7f8fa'}" :class="{'no-bg': !cardData.backgroundImage}">
    <div class="title van-ellipsis" :style="{ color: cardData.fontColor }">
      {{cardData.name}}
    </div>
    <div class="sub van-ellipsis" :style="{ color: cardData.fontColor }">
      {{cardData.description}}
    </div>
    <div class="time van-ellipsis" :style="{ color: cardData.fontColor }">有效期 {{cardData.expiredTime ? moment(cardData.expiredTime).format('YYYY-MM-DD') : ''}}</div>
    <image v-if="!cardData.backgroundImage" src="https://img.esenyun.com/images/20200530/c5d065b59f4c470e97cc04cc539eb5a3.png" />
  </div>
</template>

<script>
 import Vue from 'vue'
export default {
  props: {
    cardData: {
      type: Object,
      default: function() {
        return {}
      },
    },
    shareId:{
      type: String,
      default: "",
    },
    vcardUrl:{
      type: String,
      default: "",
    },
    vcardData:{
      type: Object,
      default: function () {
        return {};
      },
    }
  },
  mounted() {
    console.log(this.cardData)
  },
  // 组件方法
  methods: {
    async link() {
      let params = {
        packageId:this.cardData.packageId,
        posterData:this.vcardData
      }
      let redirectUri='fissionEquitys/cardDetail'
      let url=`id=${params.packageId}&shareId=${this.shareId}&vcardUrl=${this.vcardUrl}&vcardData=${encodeURIComponent(
            JSON.stringify(params.posterData)
          )}`
      console.log('url',url)
      Vue.ss.set('pageUrl',url)
      console.log('redirectUri',redirectUri)
       Vue.ss.set('redirectUri',redirectUri)
      console.log(url)
      console.log('pageUrl',Vue.ss.get('pageUrl'))
      if(this.$store.getters.isWeiXin){
        await this.$store.dispatch("wxLogin/wxLogin");
      }else{
          this.$Dialog.alert({
            message: '请在微信客户端打开链接',
          }).then(() => {
            // on close
          });
      }
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  height:128px;
  background-size: 100%;
  background-repeat: no-repeat;
  text-align: left;
  position: relative;
  .title {
    padding-top: 16px;
    width: 204px;
    font-weight: 600;
    padding-left: 16px;
    font-size: 20px;
    line-height: 22px;
  }
  .sub {
    width: 204px;
    margin-top: 4px;
    font-size: 10px;
    padding-left: 16px;
    line-height: 13px;
    opacity: 0.7;
  }
  .time {
    margin-top: 4px;
    width: 204px;
    padding-left: 16px;
    font-size: 10px;
    line-height: 13px;
    opacity: 0.7;
  }
  image {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 35px;
    right: 18px;
  }
}
.no-bg {
  background: #f7f8fa;
  border: 1px dashed #dcdde0;
}
</style>